import { Link } from 'react-router-dom';

export default function HeroBanner() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '原神本子精选',
    url: 'https://artsygen.github.io',
    description: '探索海量原神同人创作，涵盖各大角色同人漫画、插画本、小说本等丰富内容。为原神同人爱好者提供最全面的资讯与推荐平台。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://artsygen.github.io/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Genshin%20Impact%20artistic%20illustration%20with%20multiple%20characters%20in%20warm%20Chinese%20ink%20wash%20painting%20style%2C%20traditional%20scroll%20aesthetic%2C%20soft%20watercolor%20texture%2C%20cream%20and%20golden%20warm%20tones%2C%20majestic%20mountain%20landscape%20background%2C%20floating%20petals%20and%20butterflies%2C%20elegant%20composition%2C%20atmospheric%20lighting%2C%20artistic%20doujinshi%20cover%20quality&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
            alt="原神同人创作精选合集"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide leading-tight">
            探索提瓦特的<br className="md:hidden" />同人创作世界
          </h1>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
            精选原神同人漫画、插画本、小说本等海量创作 ——<br className="hidden sm:block" />
            为每一位原神同人爱好者打造最全面的创作交流与推荐平台
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/character-doujin"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览作品
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-white/15 text-white border border-white/30 font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </>
  );
}